<template>
  <div>
    <Header title="Eureko Sigorta"></Header>
    <slot/>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/desktop/widget/header'
import Footer from '@/desktop/widget/footer'
export default {
  name: 'App',
  components: {
    Header, Footer
  },
  mounted () {
    this.eventHub.eventHub.$emit('desktopActive', {
      value: true
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/desktop/template/Default.vue